var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgPayout = function SvgPayout(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.84 5c-1.088-2.92-3.901-5-7.2-5a7.68 7.68 0 1 0 7.412 9.7H10.85a2.35 2.35 0 0 1 0-4.7h4.99Z",
    fill: "#F7931A"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.843 1.561a.96.96 0 0 0 0 1.358L20.325 6.4H10.88a.96.96 0 1 0 0 1.92h9.445l-3.482 3.481a.96.96 0 0 0 1.358 1.358L24 7.36l-5.799-5.799a.96.96 0 0 0-1.358 0Z",
    fill: "currentColor"
  })));
};
export default SvgPayout;